import React from 'react';
import { useTranslation } from '../../contexts/TranslationContext';
import { TotalLine, pct } from '../../utils/matchAnalysis';

interface TotalsLadderProps {
  totals: TotalLine[];
}

const TotalsLadder: React.FC<TotalsLadderProps> = ({ totals }) => {
  const { t } = useTranslation();
  const d = t.matchDashboard;

  return (
    <div className="dash-card">
      <div className="dash-card__head">
        <h3 className="dash-card__title">{d.overUnder}</h3>
        <span className="dash-card__caption">
          {d.over} / {d.under}
        </span>
      </div>
      <div className="totals-ladder">
        {totals.map((l) => (
          <div key={l.line} className="totals-ladder__row">
            <span className={`totals-ladder__pct${l.over >= 0.5 ? ' totals-ladder__pct--lead' : ''}`}>
              {pct(l.over)}
            </span>
            <span className="totals-ladder__track">
              <span className="totals-ladder__over" style={{ width: pct(l.over, 2) }} />
              <span className="totals-ladder__line">{l.line}</span>
            </span>
            <span className={`totals-ladder__pct${l.under > 0.5 ? ' totals-ladder__pct--lead' : ''}`}>
              {pct(l.under)}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default TotalsLadder;
